/**
 * Tiny synth-based sound effects (no assets needed). Uses Web Audio API.
 * Call sfx.meow(), sfx.purr(), sfx.pop(), sfx.victory().
 */

let ctx = null;
let muted = false;

function getCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      ctx = new AC();
    } catch (e) {
      return null;
    }
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone({ freq = 440, dur = 0.25, type = "sine", vol = 0.18, attack = 0.005, decay = 0.08, glideTo = null, delay = 0 }) {
  const c = getCtx();
  if (!c || muted) return;
  const t0 = c.currentTime + delay;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (glideTo) osc.frequency.exponentialRampToValueAtTime(Math.max(1, glideTo), t0 + dur);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(vol, t0 + attack);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.05);
}

const sfx = {
  setMuted(v) {
    muted = v;
    try {
      localStorage.setItem("milkos_muted", v ? "1" : "0");
    } catch (e) {
      /* noop */
    }
  },
  isMuted() {
    try {
      if (localStorage.getItem("milkos_muted") === "1") muted = true;
    } catch (e) {
      /* noop */
    }
    return muted;
  },
  meow() {
    if (this.isMuted()) return;
    // Cat meow — pitched sweep down then up
    tone({ freq: 780, glideTo: 520, dur: 0.16, type: "triangle", vol: 0.16, attack: 0.01, decay: 0.14 });
    tone({ freq: 520, glideTo: 640, dur: 0.14, type: "triangle", vol: 0.14, delay: 0.15 });
  },
  purr() {
    if (this.isMuted()) return;
    // low rumble
    tone({ freq: 90, dur: 0.42, type: "sawtooth", vol: 0.09 });
    tone({ freq: 60, dur: 0.44, type: "square", vol: 0.05, delay: 0.03 });
  },
  pop() {
    if (this.isMuted()) return;
    tone({ freq: 1200, glideTo: 300, dur: 0.09, type: "sine", vol: 0.22, attack: 0.002, decay: 0.06 });
  },
  boop() {
    if (this.isMuted()) return;
    tone({ freq: 660, dur: 0.08, type: "triangle", vol: 0.14 });
    tone({ freq: 880, dur: 0.09, type: "triangle", vol: 0.14, delay: 0.06 });
  },
  victory() {
    if (this.isMuted()) return;
    // C major arpeggio
    [523, 659, 784, 1046].forEach((f, i) =>
      tone({ freq: f, dur: 0.16, type: "triangle", vol: 0.16, delay: i * 0.09 }),
    );
  },
  sad() {
    if (this.isMuted()) return;
    [400, 320, 260].forEach((f, i) =>
      tone({ freq: f, dur: 0.18, type: "sine", vol: 0.14, delay: i * 0.1 }),
    );
  },
};

// restore muted state on module load
if (typeof window !== "undefined") {
  try {
    if (localStorage.getItem("milkos_muted") === "1") muted = true;
  } catch (e) {
    /* noop */
  }
}

export default sfx;
